import { useEffect, useState } from 'react';
import { AddInError, getUserEmail, handleError } from '@utils-global';

const POLL_INTERVAL = 100; // ms
const READY_TIMEOUT = 10_000; // ms

export type MailboxReadyStatus = 'loading' | 'ready' | 'timeout';

export const useMailboxReady = (): MailboxReadyStatus => {
  const [status, setStatus] = useState<MailboxReadyStatus>(() =>
    getUserEmail() ? 'ready' : 'loading',
  );

  useEffect(() => {
    if (status !== 'loading') {
      return undefined;
    }

    const start = performance.now();
    const timer = setInterval(() => {
      if (getUserEmail()) {
        clearInterval(timer);
        setStatus('ready');
        return;
      }

      if (performance.now() - start <= READY_TIMEOUT) {
        return;
      }

      clearInterval(timer);
      setStatus('timeout');
      handleError(
        new AddInError('Mailbox userProfile.emailAddress never populated', {
          timeoutMs: READY_TIMEOUT,
        }),
      );
    }, POLL_INTERVAL);

    return () => clearInterval(timer);
  }, [status]);

  return status;
};
